import React, { useEffect } from 'react'
import { matchDomains } from '../../core/domain/domain'
import { evalJSONContext, evalJSONDomain } from '../../util/util'

const Field = (props) => {
  const [invisible, setInvisible] = React.useState(true)
  const [required, setRequired] = React.useState(false)
  const [readonly, setReadOnly] = React.useState(false)
  const [context, setContext] = React.useState({})
  const [domain, setDomain] = React.useState([])
  const { invisible: inv, required: req, readonly: rea, onchangeData, rootField, index, name, context: ctx, contextObj, domain: dom } = props
  const nameField = rootField ? `${rootField?.name}.${index}.${name}` : null

  useEffect(() => {
    if (onchangeData && Object.keys(onchangeData).length > 0) {
      setRequired(matchDomains(onchangeData, req))
      setInvisible(matchDomains(onchangeData, inv))
      setReadOnly(matchDomains(onchangeData, rea))
      setContext(evalJSONContext(ctx, contextObj) || {})
      setDomain(evalJSONDomain(dom, contextObj) || [])
    }
  }, [onchangeData])

  return {
    invisible,
    required,
    readonly,
    context,
    nameField,
    domain,
  }
}

export default Field
